import React from 'react'
import { useTranslation } from 'react-i18next'
import {
    Box,
    Button,
    Link,
    Typography
} from '@material-ui/core'

import { readCookie, storeCookie } from '../../utils/LocalStorage'
import { Disclaimer } from '../Atoms'
import { CookieOptionsDialog } from '../Atoms/CookieOptionsDialog'

const CONSENT_COOKIE = "cookieOptIn"
const EXPIRY_DATE = new Date()
EXPIRY_DATE.setMonth(EXPIRY_DATE.getMonth() + 6)

const consentGiven = () => {
    return readCookie(CONSENT_COOKIE) === "true"
}

const consentPending = () => {
    return readCookie(CONSENT_COOKIE) === null
}

// By separating this state into it's own component
// the rest of the component is not re-rendered
// thereby avoiding the transition effect
const DisclaimerContent = ({ variant, setUpstreamPending, setAlert }) => {
    const { t } = useTranslation()
    // eslint-disable-next-line no-unused-vars
    const [consent, setConsent] = React.useState(consentGiven())
    // eslint-disable-next-line no-unused-vars
    const [pending, setPending] = React.useState(consentPending())
    const [dialogOpen, setDialogOpen] = React.useState(false)

    const updateConsent = accepted => {
        storeCookie(CONSENT_COOKIE, accepted, EXPIRY_DATE)
        setConsent(accepted)
        setPending(false)
        setUpstreamPending(false)
        if (variant === "reminder") {
            setAlert(true)
        }
    }

    const handleOptions = () => {
        setDialogOpen(true)
    }

    const handleAccept = () => {
        updateConsent(true)
    }

    const handleDecline = () => {
        updateConsent(false)
    }

    return (
        <React.Fragment>
            <Typography variant="caption" fontSize="1.25rem" marginTop="6vh">
                {t('cookie.text')}
                <Link href="/cookies" target="_blank">{t('cookie.cookiePolicy')}</Link>.
            </Typography>
            <Box display="flex" justifyContent="space-between" alignSelf="center" flexDirection="row" >
                <Button color="primary" variant="outlined" size="small" onClick={handleOptions}>
                    <Typography fontSize="1rem">{t('cookieDialog.options')}</Typography>
                </Button>
                <Button color="primary" variant="outlined" size="small" style={{ marginLeft: 10 }} onClick={handleDecline}>
                    <Typography fontSize="1rem">{t('cookieDialog.decline')}</Typography>
                </Button>
                <Button color="primary" variant="outlined" size="small" style={{ marginLeft: 10 }} onClick={handleAccept}>
                    <Typography fontSize="1rem">{t('cookieDialog.accept')}</Typography>
                </Button>
            </Box>
            {dialogOpen && <CookieOptionsDialog dialogOpen={dialogOpen} setDialogOpen={setDialogOpen} updateConsent={updateConsent}/>}
        </React.Fragment>
    )
}

const CookieDisclaimer = ({ variant, open, setAlert }) => {
    const [, setPending] = React.useState(consentPending())

    const showDisclaimer = variant === "popup" ? (open && consentPending()) : open

    return (
        <Disclaimer open={showDisclaimer}>
            <DisclaimerContent variant={variant} setUpstreamPending={setPending} setAlert={setAlert} />
        </Disclaimer>
    )
}

export default CookieDisclaimer
export { consentGiven, consentPending }